import { Box, TextField, Tooltip, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import React, { useEffect, useState } from "react";

interface SectionHeadingProps {
  sectionName: string
  handleTitleChange: (newTitle: string) => void
}
const SectionHeading: React.FC<SectionHeadingProps> = ({ sectionName, handleTitleChange }) => {

  const [isEditing, setIsEditing] = useState(false);
  const [localTitle, setLocalTitle] = useState(sectionName || 'Untitled Section');

  // Keep localTitle in sync with the prop (e.g. after draft load) but only when not editing
  useEffect(() => {
    if (!isEditing) {
      setLocalTitle(sectionName || 'Untitled Section');
    }
  }, [sectionName]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleBlur = () => {
    setIsEditing(false);
    handleTitleChange(localTitle);
  };

  return (
    <>
      {isEditing ? (
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer', minWidth: 0 }}
        >
          <TextField
            defaultValue={sectionName || localTitle}
            onChange={(e) => setLocalTitle(e.target.value)}
            onBlur={handleBlur}
            autoFocus
            variant="standard"
            fullWidth
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault(); // prevents form submission if inside a form
                handleBlur();
              }
            }}
            slotProps={{
              htmlInput: {
                style: { fontSize: 16, fontWeight: 'bold' },
              }
            }}
          />
        </Box>
      ) : (
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer', minWidth: 0 }}
        >
          <Typography variant="h6" component="h2" noWrap sx={{ flex: 1 }}>
            {localTitle}
          </Typography>
          <Tooltip title="Edit section name">
            <EditIcon sx={{ fontSize: 16, color: 'text.secondary', flexShrink: 0 }} onClick={() => setIsEditing(true)} />
          </Tooltip>
        </Box>
      )}
    </>
  )
}

export default SectionHeading
